import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import CustomerStore from '../../stores/CustomerStore';
import Helmet from 'react-helmet';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import styles from './index.sass';

class MarketingLayout extends React.Component {
  static propTypes = {
    currentRoute: React.PropTypes.object,
    isNavigateComplete: React.PropTypes.bool,
    handler: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.string]),
    options: React.PropTypes.object
  };

  static defaultProps = {
    options: {
      hideNavbar: false,
      hideFooter: false
    }
  };

  static contextTypes = {
    getExperimentSetting: React.PropTypes.func,
    setExperimentSetting: React.PropTypes.func,
    getUserAgent: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    if(window.ENV === 'development') {return;}
    // window.Intercom("boot", {
    //   app_id: "lhqy9v4g"
    // });
  }

  getHelmetProps() {
    return {
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'},
      ]
    };
  }

  render() {
    let Handler = this.props.handler;
    let { currentRoute, isNavigateComplete, customer, options } = this.props;
    let handlerProps = { currentRoute, isNavigateComplete };
    let navbarProps = { currentRoute, customer };
    let footerProps = { hideOnMobile: true };

    return (
      <div className={styles.marketingLayout}>
        <Helmet {...this.getHelmetProps()} />
        {options.hideNavbar ? null : <Navbar {...navbarProps} />}
        <Handler {...handlerProps} />
        {options.hideFooter ? null : <Footer {...footerProps} />}
      </div>
    );
  }
}

MarketingLayout = connectToStores(MarketingLayout, [CustomerStore], (context, props) => {
  return {
    customer: context.getStore(CustomerStore).getCurrentCustomer()
  };
});

export default MarketingLayout;



// WEBPACK FOOTER //
// banquet/layouts/MarketingLayout/index.js